import { AVAILABLE_USER_COUNTRIES } from './countries.const';

export function UserCountriesBoxViewConstructor(services, callbacks, context, siteTypeConfig) {

    let joint = services.joint;
    let companyId = context.companyId;
    let site = context.site;
    let scenarioId = context.scenarioId;
    return joint.shapes.html.AbstractBoxElementWithDragAndDropView.extend({

        isElementEditable: false,

        angularTemplate: `
            <div layout="column">
                <button ng-disabled="elementView.allUserCountriesSelected()" 
                        ng-click="elementView.addUserCountries()" 
                        class="add-user-country center-block btn btn-alcmeon-default" 
                        translate-once="parameters/quick_replies/details/add_user_country"> 
                        </button> 
            </div>
            `,

        allUserCountriesSelected: function () {
            return this.model.getEmbeddedCells().length === (Object.keys(AVAILABLE_USER_COUNTRIES).length + 1);
        },

        createUserCountry: function (id, elementData) {
            const item = new joint.shapes.html.UserCountry({
                id: id,
                elementData: elementData
            });
            this.model.embed(item);
            return item;
        },

        addUserCountries: async function () {
            services.$mdDialog.show({
                controller: 'addUserCountriesBoxController',
                template: require('./addUserCountriesTemplateBox.modal.html'),
                locals: {
                    elementView: this
                }
            }).then(async result => {
                if (result && result.type === 'ok') {
                    const items = [];
                    const newItemsNumber = result.data.length;
                    const response = await services.QuickRepliesFactory.createUniqueIds(companyId, site.id, scenarioId, newItemsNumber);
                    const ids = response.data.map(element => element.id);
                    for (let index = 0; index < newItemsNumber; index++) {
                        const elementData = result.data[index];
                        items.push(this.createUserCountry(ids[index], elementData));
                    }
                    this.model.graph.addCells(items);
                }
            });
        },

        isChildAlwaysFirst: function (child) {
            return child.get('elementData').code === 'unknown';
        },

        paddingTop: function () {
            return this.heightOfHTMLContent();
        }
    });
}

